import * as S from "./ModalRegister.style";

interface ModalRegisterProps {
  title?: string;
  text?: React.ReactNode;
  toggleActive?: any;
  setModalShow: (e: boolean) => void;
  btnOff?: boolean;
}

export const ModalRegister = ({
  title,
  text,
  toggleActive,
  setModalShow,
  btnOff,
}: ModalRegisterProps) => {
  const handleToggle = () => {
    toggleActive();
    setModalShow(false);
  };
  return (
    <S.PopupAlertBox>
      <S.PopupAlert>
        <S.PopupTitle>{title}</S.PopupTitle>

        <S.PopupContent>{text}</S.PopupContent>

        <S.PopupButtons>
          <button
            type="button"
            className="cancel_btn"
            onClick={() => setModalShow(false)}
          >
            닫기
          </button>
          {btnOff === false ? (
            ""
          ) : (
            <button
              type="button"
              className="confirm_btn"
              onClick={handleToggle}
              autoFocus
            >
              동의하기
            </button>
          )}
        </S.PopupButtons>
      </S.PopupAlert>
    </S.PopupAlertBox>
  );
};
